import React, { ReactNode } from "react";
import cn from "classnames";
import { parseUrl } from "helpers";

type Props = {
    children: ReactNode;
    to?: string;
    onClick?: any;
    className?: string;
};

export default function InternalPageLink(props: Props)
{
    const className = cn(props.className && props.className);
    const to = props.to !== undefined ? props.to : null;
    const onClick = props.onClick !== undefined ? props.onClick : null;

    return (
        <a href={to} className={className} onClick={onClick}>
            {props.children}
        </a>
    );
}